//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      initShopArea:'全部',
      shopAreaList:[],
      dialogVisible:true,
      selectGoodsState:false,
      // dialog查看中的订单时间
      dialogTime:'2021-12-14',
      // dialog查看初始的数据
      infoGoodsData:[
        {goodsName:'红牛',goodsId:'2113',categoryName:'饮料',orderMoney:10,itemCount:5,payMoney:50},
        {goodsName:'洽洽',goodsId:'2114',categoryName:'零食',orderMoney:5,itemCount:5,payMoney:25},
        {goodsName:'牛肉棒0',goodsId:'2115',categoryName:'零食',orderMoney:3,itemCount:5,payMoney:15},
        {goodsName:'牛肉棒1',goodsId:'2116',categoryName:'零食',orderMoney:3,itemCount:1,payMoney:3},
        {goodsName:'牛肉棒2',goodsId:'2117',categoryName:'零食',orderMoney:4,itemCount:1,payMoney:4},
        {goodsName:'牛肉棒3',goodsId:'2118',categoryName:'零食',orderMoney:5,itemCount:1,payMoney:5},
        {goodsName:'牛肉棒4',goodsId:'2119',categoryName:'零食',orderMoney:6,itemCount:1,payMoney:6},
      ],
      // dialog查看推荐的商品
      goodsRmd:[{goodsName:'乐虎',goodsId:'1100',orderMoney:5,itemCount:0,payMoney:-1}],
      // dialog查看用于展示的商品
      goodsDableData:[],
      // dialog查看全选
      goodsListState:false,
      // dialog查看订单金额
      goodsAllMoney:0,
      accountArr:[
        {value:'老板',lable:1234},
        {value:'经理',lable:12345},
      ],
      accountArrValue:'老板',
      goodsDeleteState:false,
      goodsDeleteArr:[],
      // 被选择的商品
      selectGoods:{},
      selectGoodsTableData:[
        {goodsName:'红牛',goodsId:'2113',categoryName:'饮料',orderMoney:10,itemCount:5,payMoney:50},
        {goodsName:'洽洽',goodsId:'2114',categoryName:'零食',orderMoney:5,itemCount:5,payMoney:25},
        {goodsName:'牛肉棒0',goodsId:'2115',categoryName:'零食',orderMoney:3,itemCount:5,payMoney:15},
        {goodsName:'牛肉棒1',goodsId:'2116',categoryName:'零食',orderMoney:3,itemCount:1,payMoney:3},
        {goodsName:'牛肉棒2',goodsId:'2117',categoryName:'零食',orderMoney:4,itemCount:1,payMoney:4},
        {goodsName:'牛肉棒3',goodsId:'2118',categoryName:'零食',orderMoney:5,itemCount:1,payMoney:5},
        {goodsName:'牛肉棒4',goodsId:'2119',categoryName:'零食',orderMoney:6,itemCount:1,payMoney:6},
      ]
    }
  },
  created(){
    this.unDateGoods()
  },
  methods:{
    // 总账
    goodsAllMoneyFun(){
      this.goodsAllMoney = 0
      let checkAllState = true
      this.goodsDableData.forEach(e => {
        if(e.checked && e.payMoney>=0){
          this.goodsAllMoney += Number(e.payMoney)
        }else if(!e.checked && e.payMoney>=0){
          checkAllState = false
        }
      });
      this.goodsListState = checkAllState
      this.goodsAllMoney = this.goodsAllMoney.toFixed(2)
    },
    // 数量变化
    itemCountChange(row){
      row.payMoney = row.orderMoney * row.itemCount
      row.payMoney = row.payMoney.toFixed(2)
      this.goodsAllMoneyFun()
    },
    // 全选事件
    checkAll(){
      if(this.goodsListState){
        this.goodsDableData.forEach(e => {
          if(e.payMoney>=0){
            e.checked = true
          }
        });
      }else{
        this.goodsDableData.forEach(e => {
          if(e.payMoney>=0){
            e.checked = false
          }
        });
      }
      this.goodsAllMoneyFun()
    },
    // 删除商品
    deleteGoods(goodsArr){
      this.goodsDeleteState = false
      let data = []
      this.goodsDableData.forEach(element => {
        goodsArr.forEach(e => {
          if(element.goodsId === e){
            element.deleteState = true
          }
        })
        if(!element.deleteState){
          data.push(element)
        }
      });
      this.goodsDableData = data
      this.goodsAllMoneyFun()
    },
    // 底部更多删除
    moreDelete(){
      this.goodsDeleteArr = []
      this.goodsDableData.forEach(e => {
        if(e.checked && e.payMoney>0){
          this.goodsDeleteArr.push(e.goodsId)
        }
      });
      if(this.goodsDeleteArr.length === 0){
        this.$message('请先选择到要删除的商品！');
        return
      }
      this.goodsDeleteState = true
    },
    unDateGoods(){
      // 拼接缺货单和推荐
      this.goodsDableData = this.infoGoodsData.concat(this.goodsRmd)
      this.goodsAllMoneyFun()
    },
    emitSub(){
      this.$emit('invSubState')
    },

    selectGoodsFun(row){
      if(row === ''){
        this.selectGoods = {}
      }else{
        this.selectGoods = row
      }
      this.selectGoodsState = true
      
    }
  }

}
